var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldVideoVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.36 7.781v3.47H2v-3.47h4.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.358 2.129c-2.28.42-3.77 1.89-4.21 4.15h4.18c.01 0 .02.01.03.01v-4.16zM6.36 12.75H2v3.53h4.24c.04 0 .08.02.12.03v-3.56zM17.86 2.18v4.1h3.99c-.43-2.19-1.83-3.63-3.99-4.1zM16.36 2.01C16.31 2 16.25 2 16.19 2H7.86v9.25h8.5V2.01z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12.75v3.53h-4.14v-3.53H22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.84 17.781h-3.98v4.04c2.14-.47 3.54-1.89 3.98-4.04zM2.16 17.782c.46 2.22 1.94 3.67 4.2 4.09v-4.11c-.04.01-.08.02-.12.02H2.16z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 7.781v3.47h-4.14v-3.47H22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.86 22h8.33c.06 0 .12 0 .17-.01v-9.24h-8.5V22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldVideoVertical);
export default __webpack_public_path__ + "static/media/vuesax-bold-video-vertical.73db4992faa9809e78653a8c7361c8cc.svg";
export { ForwardRef as ReactComponent };